import React from 'react';
import styled from '@emotion/styled';

import { turquoise, smokeWhite } from '~/styles';

interface Props {
  percentComplete: number;
}

const OuterBar = styled.div`
  position: relative;
  background: ${smokeWhite};
  height: 10px;
  bottom: 0;
  width: 100%;
`;

const InnerBar = styled.div`
  position: absolute;
  background: ${turquoise};
  height: 100%;
`;

export const ProgressBar: React.FC<Props> = ({ percentComplete }) => {
  return (
    <OuterBar>
      <InnerBar style={{ width: `${percentComplete}%` }} />
    </OuterBar>
  );
};
